import type { ReactElement } from 'react'
import { useCallback, useContext, useMemo } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import LandingPageLoyaltyBenefitTile from './LandingPageLoyaltyBenefitTile'
import ModalContext from 'contexts/ModalContext'
import FormatCurrency from 'components/Common/FormatCurrency/FormatCurrency'
import LandingPageLoyaltyTravelShootCreditBenefitsModal from './LandingPageLoyaltyTravelShootCreditBenefitsModal'

interface Props {
  layout: 'tile' | 'row'
  benefit: App.LoyaltyBenefit
  benefitLabel: ReactElement
}

function LandingPageLoyaltyTravelShootCredit(props: Props) {
  const { layout, benefit, benefitLabel } = props

  const showModal = useContext(ModalContext)
  const intl = useIntl()
  const image = useMemo<App.Image>(() => ({
    id: 'r1z816jjifeqb5hwk50o',
    title: intl.formatMessage({
      id: 'sj_JEhZNdrlz5RwEG5zk',
      defaultMessage: 'Pro photos on your trip',
      description: 'Alternative text fallback for the Travelshoot loyalty benefit image',
    }),
  }), [intl])

  const handleDetailsClick = useCallback(() => {
    showModal(<LandingPageLoyaltyTravelShootCreditBenefitsModal
      image={image}
      benefitValue={benefit.value?.amount ?? 0}
    />)
  }, [benefit, image, showModal])

  return <LandingPageLoyaltyBenefitTile
    layout={layout}
    benefitType="travelshoot_credit"
    heading={<FormattedMessage
      defaultMessage="{amount} Travelshoot voucher"
      id="7_XuZ3RInsOpoRHzyyrA"
      description="Heading for loyalty Travelshoot photo credit benefit tile showing voucher value"
      values={{ amount: <FormatCurrency value={benefit.value?.amount ?? 0} format="dynamic" /> }}
    />}
    subtitle={benefitLabel}
    onClick={handleDetailsClick}
  />
}

export default LandingPageLoyaltyTravelShootCredit
